<template>
    <div class="row">
      <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader"></loading>
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <h5>Unit</h5>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <div class="form-inline ml-auto">
                <div class="button-group">
                  <button type="button" class="btn btn-sm btn-soft-primary waves-light waves-effect" @click="addUnit">
                    <i class="fa fa-plus" aria-hidden="true"></i> New
                  </button>
                  <div class="btn-group">
                    <button type="button" class="btn btn-sm  btn-soft-outline-primary waves-light waves-effect" @click="refreshList">
                      <i class="fa fa-refresh" aria-hidden="true"></i> Refresh
                    </button>
                    <!-- <button class="btn btn-success btn-sm btn-soft-outline-primary dropdown-toggle" type="button" id="action" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Action</button> -->
                    <!-- <div class="dropdown-menu" aria-labelledby="action"> -->
                      <!-- <a class="dropdown-item" href="javascript:void(0)" @click="setCOGS">Set COGS</a> -->
                    <!-- </div> -->
                  </div>
                  rows:
                  <select id="select-rows" v-model="pageSize" @change="setPageSizeOnChange">
                    <option v-for="r in rowsTable" :key="r.row" :value="r.row">{{ r.row }}</option>
                  </select>
                  <span class="mr-1">
                    Total rows: <b>{{ rowsTotal }}</b>
                  </span>
                  <date-picker v-model="startDate" type="date" range placeholder="Select date range" @change="refreshList``"></date-picker>
                </div>
                <div class="form-group mx-sm-3 mb-2">
                    <input type="search" placeholder="search..." class="form-control mr-1 input-search" v-model="searchQuery">
                </div>
                <span class="mr-1">
                  page:
                  <select v-model="currentPage">
                    <option v-for="p in pageLength" :key="p" :value="p">{{ p }}</option>
                  </select>
                  / {{ pageLength }}
                </span>
                <nav aria-label="Page navigation example" class="pull-right">
                    <ul class="pagination">
                        <li class="page-item">
                            <a class="btn btn-default btn-sm" href="javascript:void(0)" @click="prevPage">
                                <i class="fa fa-angle-left" aria-hidden="true"></i>
                            </a>
                        </li>
                        <li class="page-item">
                            <a class="btn btn-default btn-sm" href="javascript:void(0)" @click="nextPage">
                                <i class="fa fa-angle-right" aria-hidden="true"></i>
                            </a>
                        </li>
                    </ul>
                </nav>
              </div>
              <table class="table table-item mb-0 table-sm table-hover table-striped">
                  <thead>
                      <tr>
                          <th>
                            <label class="form-checkbox">
                              <input type="checkbox" v-model="selectAll" @click="select">
                              <i class="form-icon"></i>
                            </label>
                          </th>
                          <th  v-for="t in title" v-bind:key="t.prop" @click="sortTable(t.prop)">
                            {{ t.name }}
                            <div class="float-right fa" v-if="t.prop == sortColumn" v-bind:class="ascending ? 'fa-arrow-up' : 'fa-arrow-down'"></div>
                          </th>
                          <th>#</th>
                      </tr>
                  </thead>
                  <tbody>
                    <tr v-if="filterData.length < 1">
                      <td colspan="13" style="text-align: center;"><i>No Data</i></td>
                    </tr>
                      <tr v-for="(u, index) in filterData" v-bind:key="u.id" style="cursor: pointer" :class="index === idx ? 'trcolor' : null" >
                        <td>
                          <label class="form-checkbox">
                            <input type="checkbox" :value="u.id" v-model="selected" class="custom--checkbox">
                            <i class="form-icon"></i>
                          </label>
                        </td>
                        <td>
                          <span class="badge badge-warning" v-if="u.status === 'scheduled'">{{ u.status }}</span>
                          <span class="badge badge-success" v-else-if="u.status === 'check'">{{ u.status }}</span>
                          <span class="badge badge-info" v-else-if="u.status === 'start'">{{ u.status }}</span>
                          <span class="badge badge-primary" v-else-if="u.status === 'finish'">{{ u.status }}</span>
                        </td>
                        <td>{{ u.unit_no }}</td>
                        <td class="text-center"><b>{{ u.internal_number }}</b></td>
                        <td>{{ u.unit_date | dateFormat('DD/MM/YYYY') }}</td>
                        <td>{{ u.type }}</td>
                        <td>{{ u.schedule_date | dateFormat('DD/MM/YYYY') }} | <b>{{ u.schedule_date | dateFormat('H:m') }}</b></td>
                        <td>{{ u.storage_out | dateFormat('DD/MM/YYYY') }}</td>
                        <td>{{ u.start_date | dateFormat('DD/MM/YYYY') }}</td>
                        <td>{{ u.finish_date | dateFormat('DD/MM/YYYY') }}</td>
                        <td>{{ u.customer }}</td>
                        <td>{{ u.check_by }}</td>
                        <td>{{ u.created_by }}</td>
                        <td>{{ u.fuel_bar }}</td>
                        <td>{{ u.fuel_total }} {{ u.fuel_uom }}</td>
                        <td>
                          <button type="button" class="btn btn-sm btn-primary" @click="editUnit(u.id)">Edit</button>
                          <button type="button" class="btn btn-sm btn-info" @click="showUnit(u.id)">Action</button>
                        </td>
                      </tr>
                  </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { getHeader, unitUrl } from '../../config'
import DatePicker from 'vue2-datepicker'

export default {
  name: 'UnitList',
  props: ['scroll', 'idx'],
  components: {
    Loading,
    DatePicker
  },
  data () {
    var date = new Date()
    const date1 = new Date(date.getFullYear(), date.getMonth(), date.getDate())
    const date2 = new Date(date.getFullYear(), date.getMonth(), date.getDate())
    return {
      startDate: [date1, date2],
      publicPath: process.env.BASE_URL,
      dateNow: new Date(),
      view: 'table',
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#6ED861',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      dataRaw: [],
      filterCategory: [],
      filterType: [],
      data: {},
      searchQuery: '',
      ascending: false,
      sortClick: false,
      sortColumn: '',
      pageSize: 100,
      currentPage: 1,
      title: [{
        name: 'Status',
        prop: 'status'
      }, {
        name: 'Unit No',
        prop: 'unit_no'
      }, {
        name: 'Internal Number',
        prop: 'internal_number'
      }, {
        name: 'Date',
        prop: 'unit_date'
      }, {
        name: 'Type',
        prop: 'type'
      }, {
        name: 'Schedule',
        prop: 'schedule_date'
      }, {
        name: 'Storage Out',
        prop: 'storage_date'
      }, {
        name: 'Start',
        prop: 'start_date'
      }, {
        name: 'Finish',
        prop: 'finish_date'
      }, {
        name: 'Customer',
        prop: 'customer'
      }, {
        name: 'Check By',
        prop: 'check_person'
      }, {
        name: 'Create By',
        prop: 'created_by'
      }, {
        name: 'Bar',
        prop: 'fuel_bar'
      }, {
        name: 'Fuel',
        prop: 'fuel_total'
      }],
      selectAll: false,
      selected: []
    }
  },
  mounted () {
    this.refreshList()
  },
  computed: {
    ...mapState({
      authUser: state => state.users.authUser,
      rowsTable: state => state.data.rowsTable
    }),
    pageLength: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).filter(d => {
            if (this.filterCategory.length > 0) {
              for (let i = 0; i < this.filterCategory.length; i++) {
                if (d.category_id === this.filterCategory[i]) {
                  return d
                }
              }
            } else {
              return d
            }
          }).length
      }
      var length = count / this.pageSize

      return Math.ceil(length)
    },
    rowsTotal: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).filter(d => {
            if (this.filterCategory.length > 0) {
              for (let i = 0; i < this.filterCategory.length; i++) {
                if (d.category_id === this.filterCategory[i]) {
                  return d
                }
              }
            } else {
              return d
            }
          }).length
      }
      // console.log(count)
      return count
    },
    filterData () {
      var col = this.sortColumn
      var ascending = this.ascending
      return this.dataRaw.slice().sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      }).filter(d => {
        if (this.filterCategory.length > 0) {
          for (let i = 0; i < this.filterCategory.length; i++) {
            if (d.category_id === this.filterCategory[i]) {
              return d
            }
          }
        } else {
          return d
        }
      }).filter(d => {
        for (var name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
              return d
            }
          }
        }
      }).filter((row, index) => {
        var start = (this.currentPage - 1) * this.pageSize
        var end = this.currentPage * this.pageSize
        if (index >= start && index < end) return true
      })
    }
  },
  methods: {
    viewChange: function (v) {
      this.view = v
    },
    setPageSizeOnChange: function () {
      this.currentPage = 1
    },
    sortTable: function sortTable (col) {
      this.currentPage = 1
      if (this.sortColumn === col) {
        this.ascending = !this.ascending
      } else {
        this.ascending = true
        this.sortColumn = col
      }
    },
    nextPage: function () {
      if ((this.currentPage * this.pageSize) < this.rowsTotal) this.currentPage++
    },
    prevPage: function () {
      if (this.currentPage > 1) this.currentPage--
    },
    select () {
      this.selected = []
      if (!this.selectAll) {
        for (var i in this.filterData) {
          this.selected.push(this.filterData[i].id)
        }
      }
    },
    editUnit (id) {
      axios.get(unitUrl + '/' + id, { headers: getHeader() })
        .then(response => {
          this.$emit('editUnit', response.data.data)
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    showUnit (id) {
      axios.get(unitUrl + '/' + id, { headers: getHeader() })
        .then(response => {
          this.$emit('showUnit', response.data.data)
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    addUnit () {
      this.$emit('newUnit', true)
    },
    refreshList () {
      this.$Progress.start()
      this.loader.isLoading = true
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var url = unitUrl + '?begin=' + begin + '&end=' + end
      axios.get(url, { headers: getHeader() })
        .then(response => {
          this.dataRaw = response.data.data
          this.$Progress.finish()
          this.loader.isLoading = false
          this.searchQuery = ''
          window.scrollTo(0, this.scroll)
        })
        .catch(error => {
          this.loader.isLoading = false
          this.$Progress.finish()
          console.log(error)
          console.log(error.response)
          this.$swal('ERror', error.response.data.message, 'error')
          throw error
        })
    }
  }
}
</script>
